const setComponentName = (component, name) => component.displayName = name;
export default setComponentName;